import React from 'react';

import type { Props } from '../types/PageLoadMarkProps.ts';

import { UFOLoadMark } from './UFOLoadMark.tsx';

/**
 * Component that records a UFO custom mark for page load.
 */
export const PageLoadMark = (props: Props) => {
	return <UFOLoadMark {...props} />;
};
